import { createClient } from "contentful";

export const client = createClient({
  space: process.env.REACT_APP_API_KEY,
  accessToken: process.env.REACT_APP_API_TOKEN,
});
